import React from "react";

export default function AlwaseetStatuses() {
  return <div>حالات طلبات الوسيط</div>;
}